var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bidders-list tab-table"},[(_vm.initialized)?_c('settlement-table',{attrs:{"hide-actions":_vm.hideActions,"excludeSearchFields":['first_name', 'last_name', 'company_name'],"enableFrontendExport":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }